import React, { useRef, useState, useEffect } from "react";
import {
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import Invoice from "../../components/Invoice";
import { ReactComponent as Close } from "../../assets/close.svg";
import ButtomSave from "../../components/ButtomSave";
import { LoadingSpinner } from "../../components/Loading";
import axios from "axios";
import PaymentStatus from "../../components/PaymanetStatus";
import { QRCodeCanvas } from "qrcode.react";
import { isMobile } from "react-device-detect";
import { useStore } from "../../lib/store";
import { AmplitudeLog } from "../../lib/amplitude";
import { HandleShare } from "../../lib/utils";
import Product from "./Product";
import { GenerateInvoice } from "./request_create_invoice";
import { toast } from "sonner";

interface Props {
  wide?: boolean
  produto: any
  produto_type: "dinamometro_tracao" | "dinamometro_palmar" | "assinatura"
  formas: "cartao" | "pix" | "boleto";
  entrada: boolean;
}

type IconKey = "error" | "success" | "processing";

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

const PaymentPixAreaCheckout: React.FC<Props> = ({ wide, produto, produto_type, formas, entrada }) => {

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const openTimeRef = useRef<number>(0);

  useEffect(() => {
    if (isOpen) {
      openTimeRef.current = Date.now();
    }
  }, [isOpen]);

  const getModalTime = () => openTimeRef.current ? Math.floor((Date.now() - openTimeRef.current) / 1000) : 0;

  const [text, set_text] = useState("Copiar código Pix");
  const [invoice, set_invoice]: any = useState();
  const { set_sync_checkout } = useStore();

  const [loading, set_loading] = useState(false);
  const { user } = useStore();
  const { external_link } = useStore();
  const { id_negocio } = useStore();
  const { id_pedido } = useStore();
  const [status_pix, set_status_pix] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const keys: any = {
    assinatura: "Assinatura",
    dinamometro_tracao: "Dinamômetro de tração",
    dinamometro_palmar: "Dinamômetro palmar"
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invoice.pix);
    } catch (err) { }
  };

  //Resolver código comentado aqui
  const ClosePaymentPix = () => {
    setTimeout(() => {
      onClose();
      set_status_pix({
        icon: "processing",
        legend: "",
        open: false,
        title: "",
      });
      set_text("Copiar código Pix");
    }, 4000);
  };

  const VerifyStatusPix = async () => {
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/get_status_invoice",
        {
          id_fatura: invoice.id_fatura.toString(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );
      if (resposta.data.status_code === 200) {
        if (resposta.data.status_invoice === "pending") {
          set_loading(true);
        }
        if (resposta.data.status_invoice === "canceled") {
          stopInterval();
          set_loading(false);
          set_status_pix({
            icon: "error",
            legend:
              "Houve uma falha no pagamento, tente novamente ou troque o método de pagamento.",
            open: true,
            title: "Falha no pagamento",
          });
          ClosePaymentPix();
        }
        if (resposta.data.status_invoice === "paid") {
          set_loading(false);
          stopInterval();
          set_status_pix({
            icon: "success",
            legend: "O pagamento foi aprovado com sucesso!",
            open: true,
            title: "Pagamento aprovado!",
          });
          ClosePaymentPix();
          set_sync_checkout(true);
        }
      } else {
        set_status_pix({
          icon: "error",
          legend: "Houve uma falha no pagamento" + resposta.data.msg,
          open: true,
          title: "Falha no pagamento",
        });
        stopInterval();
        ClosePaymentPix();
      }
    } catch (erro: any) {
      stopInterval();
      set_status_pix({
        icon: "error",
        legend: "Ocorreu uma falha de comunicação com o sistema",
        open: true,
        title: "Falha de comunicação",
      });
      ClosePaymentPix();
    }
  };

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startInterval = () => {
    setTimeout(() => {
      if (intervalRef.current) return;
      VerifyStatusPix();
      intervalRef.current = setInterval(() => {
        VerifyStatusPix();
      }, 20000);
    }, 1000)
  };


  const handleGenerateInvoice = async () => {
    set_loading(true);

    try {
      const data = await GenerateInvoice({
        id_negocio: id_negocio,
        id_pedido: id_pedido,
        produto: {
          formas_pagamento: formas,
          tipo: produto_type,
          entrada: entrada,
        }
      });

      if (data.status_code === 200) {
        onOpen();
        set_invoice(data);
        set_sync_checkout(true);
      } else {
        toast.error("Falha na geração da fatura: " + data.msg);
      }
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      set_loading(false);
    }
  };

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      <ButtonMethodPayment
        icon="pix"
        theme="white"
        onClick={() => {
          if (loading === false) {
            AmplitudeLog("Checkout_Metodo_Selecionado", {
              finalidade_pagamento: entrada ? "entrada" : produto_type,
              tipo_produto: produto_type,
              metodo_escolhido: "pix",
              origem_escolha: "primeira_etapa"
            });
            handleGenerateInvoice();
          }
        }}
        wide={wide}
        loading={loading}
      >
        Pague com Pix
      </ButtonMethodPayment>
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
        onClose={() => {
          stopInterval();
          set_loading(false);
          set_status_pix({
            icon: "processing",
            legend: "",
            open: false,
            title: "",
          });
        }}
      >
        <DrawerContent
          className={`
            w-ful
            rounded-t-[0.75rem]
            !max-h-[100dvh] ${!isMobile && "!h-[100vh] !rounded-none !border-none"
            }
            bg-white-primary
            px-[2rem]
            pb-[2rem]
            flex
            items-center
          `}
        >
          {(onClose) => (
            <div
              className={`${!isMobile ? "w-[60%]" : "w-full"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={() => { onClose(); set_text("Copiar código Pix") }}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <div className="w-[100%] flex justify-center">
                <p className="text-blue-primary text-[1.04rem] font-[700]">
                  Pagamento com Pix
                </p>
              </div>
              {!entrada &&
                <Product
                  title={produto.plano ? produto.plano : keys[produto_type]}
                  valor={produto.valor}
                  total={produto.valor_total}
                  parcelas={produto.quantidade_parcelas}
                  unidades={produto.quantidade}
                  theme="gray"
                  imagem={produto_type}
                />
              }
              <p className="text-gray-dark text-[1.04rem] mt-[1.8rem] font-[700]">
                Fatura
              </p>
              <Invoice
                duedate={entrada ? produto?.vencimento_fatura_entrada : produto?.vencimento_fatura}
                price={entrada ? produto?.entrada : produto?.valor}
                parcelas={produto?.quantidade_parcelas}
                theme="default"
                entrada={entrada}
                quantidade={produto?.quantidade}
              />
              <PaymentStatus
                icon={status_pix.icon}
                legend={status_pix.legend}
                open={status_pix.open}
                title={status_pix.title}
                close={() => set_status_pix({
                  icon: "processing",
                  legend: "",
                  open: false,
                  title: "",
                })}
              />
              <hr />
              {!loading ? (
                <div>
                  <p className="text-gray-dark text-[1rem] mt-[1.75rem] font-[700]">
                    QR Code
                  </p>
                  <p className="">Aponte a câmera do celular para pagar</p>
                  <div className="flex justify-center my-[1.8rem]">
                    <QRCodeCanvas
                      value={invoice?.pix}
                      size={120}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                    />
                  </div>
                  <div
                    className={`flex  ${!isMobile ? "flex-row" : "flex-col"
                      }  gap-[0.75rem]`}
                  >
                    <ButtomSave
                      icon="copy"
                      theme="mediumgreen"
                      onClick={() => {
                        handleCopy();
                        startInterval();
                        set_text("Código Pix copiado!");
                        AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                          acao: "copiar_codigo",
                          tempo_permanencia_modal: getModalTime()
                        });
                      }}
                    >
                      {text}
                    </ButtomSave>
                    {external_link === false && isMobile && (
                      <ButtomSave
                        icon="share"
                        theme="white"
                        onClick={() => {
                          HandleShare(invoice.pix);
                          startInterval();
                          AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                            acao: "compartilhar",
                            tempo_permanencia_modal: getModalTime()
                          });
                        }}
                      >
                        Compartilhar
                      </ButtomSave>
                    )}
                  </div>
                  <div className="flex flex-row items-center mt-[1rem] mb-[1rem]">
                    <p className="mr-1">Já fez o pagamento?</p>
                    <p
                      className="underline decoration-solid text-gray-dark"
                      onClick={() => {
                        startInterval();
                        AmplitudeLog("Checkout_Interacao_Pagamento_Off", {
                          acao: "confirmar_pagamento",
                          tempo_permanencia_modal: getModalTime()
                        });
                      }}
                    >
                      Clique aqui
                    </p>
                  </div>
                </div>
              ) : (
                <div className="w-[100%] flex items-center flex-col mt-[1.5rem]">
                  <LoadingSpinner className="w-[3.12rem] h-[3.12rem] text-green-medium" />
                  <p className="text-gray-dark text-[1.12rem] mt-[1.25rem] font-[700]">
                    Pagamento sendo processado
                  </p>
                </div>
              )}
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PaymentPixAreaCheckout;
